import '../styles/Mapa.css';
import { Typography, Row } from 'antd';
const { Title } = Typography;

const Mapa = () => {
  return (
    <div id="mapa">
      <Row justify="center">
        <Title level={2} className="title-responsive">
          Ubicación
        </Title>
      </Row>
      <div className="map-fixed">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.2389845081393!2d-65.2368484!3d-26.768651!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94225d45877e137b%3A0x2111d7edde3a9e88!2sIglesia%20Visi%C3%B3n%20Apost%C3%B3lica%20Lomas%20de%20Taf%C3%AD!5e0!3m2!1ses-419!2sar!4v1743365903158!5m2!1ses-419!2sar"
          width="600"
          height="450"
          allowFullScreen=""
          loading="lazy"
          title="Iglesia Vision Apostolica Lomas de Tafí"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default Mapa;
